import { useMemo } from 'react';
import { ClinicSessionUtilization } from '../../api/internal';
import { useAuthentication } from '../../auth';
import { useTenantIds } from '../../hooks/useTenantIds';
import { buildMonthlySessions } from './utilizationAggregates';

export interface MonthlySessionsSummary {
  clinic: string;
  year: number;
  month: number;
  patients: number;
  sessions: number;
  totalReps: number;
  totalTimeTaken: number;
  repsPerPatient: number;
  repsPerSession: number;
  timeTakenPerPatient: number;
  timeTakenPerSession: number;
  sessionsPerPatient: number;
}

export function useMonthlySessions(clinicSessions: ClinicSessionUtilization[]): MonthlySessionsSummary[] {
  const currentUser = useAuthentication();
  const tenantIds = useTenantIds();

  return useMemo(
    () => buildMonthlySessions(clinicSessions, currentUser.subtenants, tenantIds),
    [clinicSessions, currentUser, tenantIds]
  );
}
